import { COORDONNEES_CHECK_STATUS } from '@/enums/coordonneesCheck';

// validation-token : les trois refus partagent le 200, seul le `message` du
// corps les sépare. La branche « token trop vieux » répond sans `success`.
const CODE_CHECK_ERROR_KEY_BY_MESSAGE: Record<string, string> = {
  'Code errone': 'justificatifsUniversign.invalidCode',
  'Token trop vieux': 'justificatifsUniversign.expiredCode',
  'Erreur de la lecture du code': 'justificatifsUniversign.unknownCode',
};
const CODE_CHECK_ERROR_KEY_BY_STATUS: Record<number, string> = {
  401: 'justificatifsUniversign.missingCode',
};
// 404 « souscription introuvable » : seul refus du lot dont le message porte le
// numéro du Service Client. Il se rend donc à part.
const CODE_CHECK_UNKNOWN_SOUSCRIPTION_STATUS = 404;
const CODE_CHECK_GENERIC_ERROR_KEY = 'justificatifsUniversign.codeGenericError';

// La re-saisie du téléphone n'ouvre aucune modale : chaque échec, y compris
// `error`, s'affiche sous la carte pour que le client puisse corriger ou réessayer.
const PHONE_CHECK_MESSAGE_KEY: Record<Exclude<COORDONNEES_CHECK_STATUS, COORDONNEES_CHECK_STATUS.VALID>, string> = {
  [COORDONNEES_CHECK_STATUS.ALREADY_USED]: 'justificatifsUniversign.phoneMismatch',
  [COORDONNEES_CHECK_STATUS.SEND_FAILED]: 'justificatifsUniversign.phoneSendError',
  [COORDONNEES_CHECK_STATUS.MISSING_CONTACT_DETAILS]: 'justificatifsUniversign.phoneMissingError',
  [COORDONNEES_CHECK_STATUS.CODE_SEND_FAILED]: 'justificatifsUniversign.coordonneesCodeSendError',
  [COORDONNEES_CHECK_STATUS.ERROR]: 'justificatifsUniversign.phoneGenericError',
};

// Chaque refus documenté par le back a son message sous la carte, l'adresse restant
// modifiable. `error` est volontairement absent : le client ne peut rien en faire,
// il bascule sur le repli « contacter un conseiller ».
const EMAIL_CHECK_MESSAGE_KEY: Partial<Record<COORDONNEES_CHECK_STATUS, string>> = {
  [COORDONNEES_CHECK_STATUS.ALREADY_USED]: 'justificatifsUniversign.emailMismatch',
  [COORDONNEES_CHECK_STATUS.SEND_FAILED]: 'justificatifsUniversign.emailSendError',
  [COORDONNEES_CHECK_STATUS.MISSING_CONTACT_DETAILS]: 'justificatifsUniversign.emailMissingError',
  [COORDONNEES_CHECK_STATUS.CODE_SEND_FAILED]: 'justificatifsUniversign.coordonneesCodeSendError',
};

export {
  CODE_CHECK_ERROR_KEY_BY_MESSAGE,
  CODE_CHECK_ERROR_KEY_BY_STATUS,
  CODE_CHECK_GENERIC_ERROR_KEY,
  CODE_CHECK_UNKNOWN_SOUSCRIPTION_STATUS,
  EMAIL_CHECK_MESSAGE_KEY,
  PHONE_CHECK_MESSAGE_KEY,
};
